import { render, staticRenderFns } from "./reset_password.vue?vue&type=template&id=353db2ba&scoped=true"
import script from "./reset_password.vue?vue&type=script&lang=js"
export * from "./reset_password.vue?vue&type=script&lang=js"
import style0 from "./reset_password.vue?vue&type=style&index=0&id=353db2ba&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "353db2ba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('353db2ba')) {
      api.createRecord('353db2ba', component.options)
    } else {
      api.reload('353db2ba', component.options)
    }
    module.hot.accept("./reset_password.vue?vue&type=template&id=353db2ba&scoped=true", function () {
      api.rerender('353db2ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/mdm/views/user_management/form/components/reset_password/reset_password.vue"
export default component.exports